module.exports = __webpack_public_path__ + "img/whatsapp.33b6530c.png";